import React, { useState } from "react";

/**
 * NexaReach Logo component.
 *
 * To replace the logo, drop a transparent PNG at
 *   /app/frontend/public/logo.png
 * (a square 200x200 or a horizontal 600x200 both work; aspect ratio is preserved).
 *
 * Props:
 *   height: pixel height (logo width auto-scales).
 *   showFallbackWordmark: when the image fails to load, also render the
 *     "NexaReach · Marketing Partner · Vantage Markets" text fallback.
 */
const LOGO_SRC = "/logo.png";

export default function Logo({ height = 44, showFallbackWordmark = true }) {
    const [imgFailed, setImgFailed] = useState(false);

    if (imgFailed) {
        return (
            <div className="flex items-center gap-3" data-testid="brand-logo">
                <div
                    className="border border-[#C8A064] flex items-center justify-center shrink-0"
                    style={{ width: height, height }}
                >
                    <span
                        className="font-serif-display text-[#C8A064] leading-none"
                        style={{ fontSize: height * 0.55, marginTop: 2 }}
                    >
                        N
                    </span>
                </div>
                {showFallbackWordmark && (
                    <div className="leading-tight">
                        <div className="font-serif-display text-lg text-[#F3F4F6] tracking-wide">
                            NexaReach
                        </div>
                        <div className="overline text-[9px]">
                            Marketing Partner · Vantage Markets
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return (
        <img
            src={LOGO_SRC}
            alt="NexaReach LLC — Unlocking Growth"
            onError={() => setImgFailed(true)}
            style={{ height, width: "auto" }}
            className="object-contain shrink-0 select-none"
            data-testid="brand-logo"
        />
    );
}
